import React from 'react';

import { Gutter, Tabs } from '@common/components';
import { useNavigate, useQuery, useParams } from '@common/hooks';
import { MissionControlBasePage } from '@institutions/pages';
import { MISSION_CONTROL_DISPUTES_STATE_COUNT_QUERY } from '@pay-bill/graphql/queries';
import { MissionControlBillingTable } from './_mission-control-billing-table';

const { Tab, Pane } = Tabs;

export function MissionControlBillingPage() {
  const navigate = useNavigate();
  const { selectedTab } = useParams<{ selectedTab: string }>();
  const { data } = useQuery(MISSION_CONTROL_DISPUTES_STATE_COUNT_QUERY);
  const counts = data?.missionControlDisputesStateCount;

  return (
    <MissionControlBasePage section="billing">
      <Tabs
        defaultActiveKey={selectedTab}
        onTabClick={(key) =>
          navigate(`/works/home/billing/${key}`, { replace: true })
        }
      >
        <Pane
          tab={
            <Tab
              title="Open Disputes"
              count={counts ? counts.open + counts.redirected : 0}
            />
          }
          key="open"
        >
          <Gutter size="lg" direction="vertical">
            <MissionControlBillingTable
              defaultStateFilters={['open', 'redirected']}
            />
          </Gutter>
        </Pane>
        <Pane
          tab={
            <Tab
              title="Approved Disputes"
              count={counts ? counts.approved : 0}
            />
          }
          key="approved"
        >
          <Gutter size="lg" direction="vertical">
            <MissionControlBillingTable defaultStateFilters={['approved']} />
          </Gutter>
        </Pane>
      </Tabs>
    </MissionControlBasePage>
  );
}
